The SEEK products that the candidate may be surfaced in.

Currently, two codes are defined:

- `CandidateManagement` indicates that the candidate may be viewed in SEEK Candidate Management.
- `ProactiveSourcing` indicates that the candidate may be viewed in SEEK Talent Search.
